import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Divider, Input, message } from 'antd'
import { CenteredSpin, LoadingContainer, PrimaryButton, PrimaryIconButton } from '../ui'
import style from './style.m.less'
import useRequest, { RequestTypes } from '../hooks/useRequest'
import { AGValidityPeriodResponse } from './types'
import { SuccessMessage } from '../Edit/components'
import {useCurrentUser} from "../hooks/useCurrentUser";
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {signBody} from "../helpers";

const AGValidityPeriod: FC = () => {
    const { t } = useTranslation()

    const [currentPeriod, setCurrentPeriod] = useState<number>()
    const [period, setPeriod] = useState<number>()

    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const { fetch: getPeriod, isLoading } = useRequest({
        link: '/api/settings/v1/settings/ga-ttl',
        method: RequestTypes.get,
    })

    const { fetch: setPeriodQuery } = useRequest({
        link: '/api/settings/v1/settings/ga-ttl',
        method: RequestTypes.post,
    })

    const onApplyClick = async () => {
        const body = {
            ga_ttl: period
        }
        if (isUserAdmin) {
            const { request_id, signature } = await signBody(body, data)
            setPeriodQuery({
                body,
                getParams: {
                    request_id,
                },
                config: {
                    headers: {
                        Signature: signature,
                    },
                },
                onSuccess: () => {
                    message.success({
                        content: (
                            <SuccessMessage
                                header={t('detailedCard.success')}
                                message={'Срок успешно изменен'}
                            />
                        ),
                        icon: <></>,
                    })
                    setCurrentPeriod(period)
                },
            })
        } else {
            setPeriodQuery({
                body,
                onSuccess: () => {
                    message.success({
                        content: (
                            <SuccessMessage
                                header={t('detailedCard.success')}
                                message={'Срок успешно изменен'}
                            />
                        ),
                        icon: <></>,
                    })
                    setCurrentPeriod(period)
                },
            })
        }
    }

    useEffect(() => {
        getPeriod({
            onSuccess: (result: AGValidityPeriodResponse) => {
                setCurrentPeriod(result.ga_ttl)
                setPeriod(result.ga_ttl)
            },
        })
    }, [])

    return (
        <div className={style.main}>
            <LoadingContainer isLoading={isLoading}>
                <div className={style.header}>Срок действия атрибутов генерации</div>
                <div className={style.content}>
                    <div className={style.infoBlock}>
                        <div>Срок действия АГ (в месяцах)</div>
                        <Input
                            value={period}
                            onChange={(event) => {
                                const value = parseInt(event.target.value, 10)
                                setPeriod(Number.isNaN(value) ? undefined : value)
                            }}
                            className={style.input}
                        />
                        <div className={style.label}>Число от 1 до 12</div>
                        <Alert
                            className={style.alert}
                            type="info"
                            message="Обращаем внимание, что срок действия АГ может быть сокращен до конца марта следующего года, если экспирация АГ наступит в следующем году начиная с апреля"
                        />
                    </div>
                    <Divider />
                    {(isEmptySign || isSignExpired) && (
                        <Alert
                            className={style.signError}
                            message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                            type="error"
                            showIcon
                        />
                    )}
                    <div className={style.buttonWrapper}>
                        <PrimaryButton
                            onClick={() => setPeriod(currentPeriod)}
                            value={t('documents.cancel')}
                            isCancel
                            customStyle={{ padding: '8px 16px' }}
                        />
                        <PrimaryIconButton
                            size="large"
                            disabled={
                                period === undefined || period <= 0 || period === currentPeriod
                                || isEmptySign || isSignExpired
                            }
                            onClick={onApplyClick}
                            value={isUserAdmin ? t('settings.signAndApplyBtn') : t('settings.applyBtn')}
                            customStyle={{ padding: '8px 16px' }}
                        />
                    </div>
                </div>
            </LoadingContainer>
        </div>
    )
}

export default AGValidityPeriod
